import { AxiosInstance } from 'axios';
import { QueryStringBuilder } from '../helpers';
import { IPagedList, IPagination, IUser, IUserQuery } from '../models';
import { ArgumentValidator } from '@/shared/helpers';
import { IListOrganizationalUnitPathsRequest } from '../models/list-organizational-unit-paths-request';

export class UserClient {

    constructor(private axiosClient: AxiosInstance) {

    }

    public get apiUrl() {
        return `/user`;
    }

    public async search(query?: IUserQuery, pagination?: IPagination): Promise<IPagedList<IUser>> {

        const url = new QueryStringBuilder()
            .withPaginationIfNotEmpty(pagination)
            .build(`${this.apiUrl}/search`);

        try {
            const response = await this.axiosClient.post(
                url,
                query ? query : {},
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

            return response.data;

        } catch (error: any) {
            throw error.response.data;
        }
    }

    public async listOrganizationalUnitPaths(request?: IListOrganizationalUnitPathsRequest): Promise<string[]> {

        const url = new QueryStringBuilder()
            .withQueryIfNotEmpty('baseSegment', request?.baseSegment)
            .withQueryArrayIfNotEmpty('segmentLevels', request?.segmentLevels || [])
            .build(`${this.apiUrl}/listOrganizationalUnitPaths`)

        const response = await this.axiosClient.get(url);

        return response.data;
    }

    public async organizationalUnitPathLevelCount(fromPath: string): Promise<{ levels: number }> {

        ArgumentValidator.notNullOrEmpty(fromPath, `fromPath`);

        const url = new QueryStringBuilder()
            .withQueryIfNotEmpty('fromPath', fromPath)
            .build(`${this.apiUrl}/organizationalUnitPathLevelCount`);

        const response = await this.axiosClient.get(url);

        return response.data;
    }
}
